window.addEventListener("load", function () {
    console.log("All resources are fully loaded!");
    var titles = document.getElementsByClassName("jdgm-carousel-title");
    if (titles.length > 0) {
        titles[0].innerHTML = "Reviews From Our Customers";
    }

    var badgeText = document.querySelector(".jdgm-prev-badge__text");
    
    if (badgeText) {
        var currentText = badgeText.textContent; 

        badgeText.innerHTML = "( " + currentText + " )";
    }
    
    var priceElement = document.querySelector("span.font-bold");
    
    // Check if the element exists
    if (priceElement) {
        // Remove the class "font-bold"
        priceElement.classList.remove("font-bold");
    }






  //    const slider = $('.shop-our-coll-content-all');
  // var progressBar = $('.progress');
  // var $status = $('.pagingInfo');
  // //for first time load
  // slider.on('init', function (event, slick, currentSlide, nextSlide) {
  //   currentDot = $(".slick-dots .slick-active").index() + 1;
  //   dots = slider.find('.slick-dots li').length;
  //   calc = (currentDot / dots) * 100;
  //   progressBar.css('background-size', calc + '% 100%').attr('aria-valuenow', calc);
  //   $status.text(1 + '/' + slick.slideCount);
  // });
  
  // slider.on('afterChange', function (event, slick, currentSlide, nextSlide) {
  //   var currentDot = $(".slick-dots .slick-active").index() + 1;
  //   var dots = slider.find('.slick-dots li').length;
  //   var calc = (currentDot / dots) * 100;
  //   var currentSlideAH = $('.slick-slide.slick-current .shop-our-coll-single-item .shop-our-coll-image-main').attr('forloop');
  //   progressBar.css('background-size', calc + '% 100%').attr('aria-valuenow', calc);
  //   $status.text(currentSlideAH + '/' + slick.slideCount);
  // });
      
  // slider.slick({
  //   slidesToShow: 4,
  //   dots: false,
  //   arrows: true,
  //   infinite: true,
  //   slidesToScroll: 1,
  //   nextArrow: '<button type="button" class="slick-custom-arrow slick-custom-arrow-right"><img src="https://cdn.shopify.com/s/files/1/0665/4381/2805/files/Group_38.svg?v=1720080637" alt="arrow"></button>',
  //   prevArrow: '<button type="button" class="slick-custom-arrow slick-custom-arrow-left"><img src="https://cdn.shopify.com/s/files/1/0665/4381/2805/files/Group_39.svg?v=1720080638" alt="arrow"></button>',
  //   responsive: [
  //     {
  //       breakpoint: 1200,
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 1
  //       }
  //     },
  //     {
  //       breakpoint: 767,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 1
  //       }
  //     },
  //     {
  //       breakpoint: 575,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 1
  //       }
  //     }
  //   ]
  // });
    const slider = $('.shop-our-coll-content-all');
    const progressBar = $('.progress');
    const $status = $('.pagingInfo');

    // For first time load
    slider.on('init', function (event, slick) {
        var currentDot = $(".slick-dots .slick-active").index() + 1;
        var dots = slider.find('.slick-dots li').length;
        var calc = (currentDot / dots) * 100;
        progressBar.css('background-size', calc + '% 100%').attr('aria-valuenow', calc);
        $status.html('<strong>' + 1 + '</strong>' + '/' + slick.slideCount);
      console.log($status.length);
    });

   
     slider.on('afterChange', function (event, slick, currentSlide) {
          var currentDot = $(".slick-dots .slick-active").index() + 1;
          var dots = slider.find('.slick-dots li').length;
          var calc = (currentDot / dots) * 100;
          var currentSlideAH = $('.shop-our-coll-single-item .shop-our-coll-image-main').eq(currentSlide).attr('forloop');
          progressBar.css('background-size', calc + '% 100%').attr('aria-valuenow', calc);
          $status.text((currentSlide + 1) + '/' + slick.slideCount);
          $status.html('<strong>' + (currentSlide + 1) + '</strong>' + '/' + slick.slideCount);
      });

    // Initialize slick slider
    slider.slick({
        slidesToShow: 4,
        dots: true,
        arrows: true,
        infinite: true,
        slidesToScroll: 1,
        nextArrow: '<button type="button" class="slick-custom-arrow slick-custom-arrow-right"><img src="https://cdn.shopify.com/s/files/1/0866/4517/8681/files/Group_35814.png?v=1738944055" alt="arrow"></button>',
        prevArrow: '<button type="button" class="slick-custom-arrow slick-custom-arrow-left"><img src="https://cdn.shopify.com/s/files/1/0866/4517/8681/files/Group_35813_1.png?v=1738944114" alt="arrow"></button>',
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });


});